<section class="feature-page">
  <app-page-header title="Áreas" subtitle="Gestiona las áreas funcionales del sistema"></app-page-header>

  <div class="feature-page__content">
    <app-table-surface
      [columns]="columns"
      [data]="tableData"
      [isLoading]="isLoading"
      [enableDragDrop]="true"
      [enableSearch]="true"
      [enableSort]="true"
      [enableColumnVisibility]="true"
      [enableDensity]="true"
      tableId="area-list"
      [savingCell]="savingCell"
      [cellTemplate]="cellTemplate"
      searchPlaceholder="Buscar áreas..."
      primaryActionLabel="Nueva área"
      primaryActionIcon="add"
      (primaryActionClick)="createNew()"
      (searchChange)="onToolbarSearch($event)"
      (rowReorder)="onRowsReordered($event)"
      (cellEditSave)="onCellEditSave($event)">

      <ng-template #cellTemplate let-row="row" let-column="column">
        <span *ngIf="column === 'name'">{{ row.name }}</span>
        <mat-slide-toggle
          *ngIf="column === 'isActive'"
          class="status-toggle"
          [checked]="row.isActive"
          (click)="$event.stopPropagation()"
          (change)="onStatusChange(row, $event.checked)"
          aria-label="Cambiar estado">
        </mat-slide-toggle>

        <div *ngIf="column === 'actions'" class="table-actions">
          <button mat-icon-button type="button" matTooltip="Editar" (click)="$event.stopPropagation(); editArea(row)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button type="button" matTooltip="Eliminar" (click)="$event.stopPropagation(); deleteArea(row)">
            <mat-icon color="warn">delete</mat-icon>
          </button>
        </div>
      </ng-template>
    </app-table-surface>
  </div>
</section>
